
import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./SigninWidget.scss";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import HomeIndex from "../../components/pages/Home/HomeIndex";
import Login from "./Login";

const SigninWidget = () => {


  return (
    <>
  
    <AuthenticatedTemplate>
      <HomeIndex/>
    </AuthenticatedTemplate>

    <UnauthenticatedTemplate>
        <Login/>
    </UnauthenticatedTemplate>

    </>
  );
};

export default SigninWidget;
